export class SliderNavigation {
  type = '';
  position = 'uk-flex-center';
  margin = 'uk-margin-top';
  breakpoint = '';
  color = 'uk-dark';
}
